import {
  jb_image_css_default
} from "./chunk.MUQUSTFB.js";
import {
  reset_css_default
} from "./chunk.YAATWOBE.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Spaceable
} from "./chunk.JI7MO3NT.js";
import {
  A,
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  n
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-image/jb-image.ts
var JbImage = class extends Spaceable(i) {
  _getContentSpacingProperties() {
    return { grid: true, colsMdUp: 8, horizontal: "full-width-sm-down", type: "media" };
  }
  render() {
    return b`
      <jb-picture
        .alt=${this.picture.alt}
        .imgData=${this.picture.imgData}
        .lazy=${this.picture.lazy}
      ></jb-picture>
      ${this.caption ? b`<p class="caption">${this.caption}</p>` : A}
      ${this.text ? b`<p class="text">${this.text}</p>` : A}
      ${this.credit ? b`<p class="credit">${this.credit}</p>` : A}
    `;
  }
};
JbImage.styles = [reset_css_default, jb_image_css_default];
__decorateClass([
  n()
], JbImage.prototype, "caption", 2);
__decorateClass([
  n()
], JbImage.prototype, "credit", 2);
__decorateClass([
  n({ type: Object })
], JbImage.prototype, "picture", 2);
__decorateClass([
  n()
], JbImage.prototype, "text", 2);
JbImage = __decorateClass([
  customElement("jb-image")
], JbImage);

export {
  JbImage
};
